import { render } from "./AppMobile.vue?vue&type=template&id=4d44c8bc&scoped=true"
import script from "./AppMobile.vue?vue&type=script&lang=js"
export * from "./AppMobile.vue?vue&type=script&lang=js"

import "./AppMobile.vue?vue&type=style&index=0&id=4d44c8bc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d44c8bc"]])

export default __exports__